import React from "react";
import { useWatchState, setState } from "@/store";
import { Modal, Button, Tag } from "antd";
import "./style.less";

const { CheckableTag } = Tag;

const MODAL_STATE_PATH = "modal.video";

const Video = () => {

    const [[{ title = "", show, hide, width = 900, url }]] = useWatchState([MODAL_STATE_PATH])

    return (
        <Modal
            className="modal-video"
            title={title}
            visible={show}
            width={width}
            maskClosable={false}
            destroyOnClose
            onCancel={hide}
            footer={false}
        >
            <video controls autoPlay src={url} onPlay={show}></video>
        </Modal>
    );
}

export default Video;